<template>
  <div class="header">
    <div class="container-fluid">
      <!-- Hearer  -->
      <div class="mt-4">
        <div class="card">
          <div class="card-body">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item fw-bolder">DMS Portal</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <!-- Card  -->
      <div class="card">
        <div class="card-body mt-3 mb-3">
          <div class="row" style="margin-left: 15px; margin-right: 15px">
            <div class="col-12 col-lg-3"></div>
            <div class="col">
              <div class="form-group d-flex float-end">
                <b-button v-b-modal.modal-1 variant="primary">
                  <span class="fe fe-plus-circle"></span>
                  Create
                </b-button>
              </div>
            </div>
          </div>

          <div>
            <vue-good-table
              :line-numbers="true"
              :columns="column"
              :rows="getListSite"
              :sort-options="{
                enabled: true
              }"
              :total-rows="10"
              :pagination-options="{
                enabled: false,
                mode: 'pages',
                position: 'bottom',
                perPage: 10,
                perPageDropdown: [10, 50, 100],
                dropdownAllowAll: false,
                setCurrentPage: 1,
                nextLabel: 'next',
                prevLabel: 'prev',
                rowsPerPageLabel: 'Rows per page',
                ofLabel: 'of',
                pageLabel: 'page',
                allLabel: 'All'
              }"
              style-class="vgt-table border-0 table">
              <!-- Loading -->
              <div slot="emptystate" class="text-center font-size-14">
                No data available
              </div>
              <!-- Custom Rows -->
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'actions'">
                  <b-button
                    class="no-wrap btn-pill"
                    variant="warning"
                    size="sm"
                    @click="editVariables(props.row)">
                    <span class="fe fe-edit"></span>
                  </b-button>
                  <b-button
                    class="no-wrap ml-2"
                    variant="danger"
                    style="margin-left: 5px"
                    size="sm"
                    @click="deleteVariables(props.row.id)">
                    <span class="fe fe-trash-2"></span>
                  </b-button>
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-1" size="xl" hide-footer title="Add Site">
      <form @submit.prevent="saveVariables()">
        <div class="row g-3">
          <div class="form-group col">
            <label>Site Name<span class="text-danger">*</span></label>
            <input
              type="text"
              v-model="bodyAdd.site_name"
              class="form-control"
              placeholder="Site Name"
              v-validate="'required'"
              name="Parameter Name" />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Select App Name')"
              >{{ errors.first("Select App Name") }}</span
            >
          </div>
        </div>
        <div class="row g-3">
          <div class="form-group col">
            <label>Site URL<span class="text-danger">*</span></label>
            <input
              type="text"
              v-model="bodyAdd.site_link"
              class="form-control"
              placeholder="Site URL"
              v-validate="'required'"
              name="Parameter Name" />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Select App Name')"
              >{{ errors.first("Select App Name") }}</span
            >
          </div>
        </div>
        <div class="row g-3">
          <div class="form-group col">
            <label>Department<span class="text-danger">*</span></label>
            <v-select
              multiple
              v-model="bodyAdd.selectDepartment"
              :options="getListDepartment.data.rows"
              :reduce="(e) => e.department"
              label="department"
              v-validate="'required'"
              name="Select Form Type" />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Select App Name')"
              >{{ errors.first("Select App Name") }}</span
            >
          </div>
        </div>

        <div class="form-group">
          <button
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="submit"
            v-if="isLoading == false">
            Save
          </button>
          <button
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="button"
            disabled
            v-else>
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"></span>
            Loading...
          </button>
          <button
            type="button"
            style="margin-right: auto; float: right"
            class="mt-4 btn btn-outline-primary mr-3"
            @click="$bvModal.hide('modal-1')">
            Cancel
          </button>
        </div>
      </form>
    </b-modal>
    <b-modal id="modal-2" size="xl" hide-footer title="Edit Application">
      <form @submit.prevent="saveUpdate()">
        <div class="row g-3">
          <div class="form-group col">
            <label>Site Name<span class="text-danger">*</span></label>
            <input
              type="text"
              v-model="bodyUpdate.site_name"
              class="form-control"
              placeholder="Site Name"
              v-validate="'required'"
              name="Parameter Name" />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Select App Name')"
              >{{ errors.first("Select App Name") }}</span
            >
          </div>
        </div>
        <div class="row g-3">
          <div class="form-group col">
            <label>Site URL<span class="text-danger">*</span></label>
            <input
              type="text"
              v-model="bodyUpdate.site_link"
              class="form-control"
              placeholder="Site URL"
              v-validate="'required'"
              name="URL" />
            <span class="text-sm text-danger" v-show="errors.has('URL')">{{
              errors.first("URL")
            }}</span>
          </div>
        </div>
        <div class="row g-3">
          <div class="form-group col">
            <label>Department<span class="text-danger">*</span></label>
            <v-select
              multiple
              v-model="bodyUpdate.selectDepartment"
              :options="getListDepartment.data.rows"
              :reduce="(e) => e.department"
              label="department"
              v-validate="'required'"
              name="Select Form Type" />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Select App Name')"
              >{{ errors.first("Select App Name") }}</span
            >
          </div>
        </div>

        <div class="form-group">
          <button
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="submit"
            v-if="isLoading == false">
            Save
          </button>
          <button
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="button"
            disabled
            v-else>
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"></span>
            Loading...
          </button>
          <button
            type="button"
            style="margin-right: auto; float: right"
            class="mt-4 btn btn-outline-primary mr-3"
            @click="$bvModal.hide('modal-2')">
            Cancel
          </button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "RoleTemplate",
  computed: {
    getListSite() {
      return this.$store.getters["dms_portal/listSite"];
    },
    getListDepartment() {
      return this.$store.getters["dms_portal/listDepartment"];
    }
  },
  data() {
    return {
      departmentNames: [],
      listSite: [],
      fullname: "",
      departement: "",
      position: "",
      employee: "",
      app: "",
      role: "",
      isAdd: true,
      isRole: false,
      loadRole: false,
      isLoading: false,
      assignBy: "",
      selectFormType: "",

      usersAttribute: [],
      bodyAdd: {
        site_name: "",
        site_link: "",
        selectDepartment: []
      },
      bodyUpdate: {
        id: "",
        site_name: "",
        site_link: "",
        selectDepartment: []
      },
      column: [
        {
          label: "Site Name",
          field: "site_name",
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle"
        },
        {
          label: "Site Url",
          field: "site_link",
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle"
        },
        {
          label: "Department",
          field: "department",
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle"
        },
        {
          label: "Actions",
          field: "actions",
          thClass:
            "table-header no-wrap w-40 text-muted font-weight-bold text-center",
          tdClass: "no-wrap color-secondary align-middle text-center",
          sortable: false
        }
      ]
    };
  },

  mounted() {
    this.assignBy = localStorage.getItem("fullname");
    this.getDepartment();
    this.getUsersAttribute();
    this.getSite();
  },
  methods: {
    getDepartment() {
      this.$store
        .dispatch("dms_portal/getListDepartment")
        .then((response) => {
          let data = this.$store.getters["dms_portal/listDepartment"];
          // console.log("data get department:", data.data)
          // this.departmentNames = data.data.rows;
        })
        .catch((error) => {
          console.error("Error fetching department names:", error);
        });
    },

    getSite() {
      this.$store
        .dispatch("dms_portal/getListSite")
        .then((response) => {
          let data = this.$store.getters["dms_portal/listSite"];
          // this.listSite = data.data.rows;
        })
        .catch((error) => {
          console.error("Error fetching variables:", error);
        });
    },
    getUsersAttribute() {
      this.$store.dispatch("users/GET_LIST_USERS");
    },

    saveVariables() {
      this.$validator.validateAll().then(async (res) => {
        if (!res) return false;
        // return console.log("payload variables :", this.bodyAdd);
        this.isLoading = true;
        console.log("payload variables :", this.bodyAdd);
        try {
          let body = {
            site_name: this.bodyAdd.site_name,
            site_link: this.bodyAdd.site_link,
            department: this.bodyAdd.selectDepartment
          };
          this.$store.dispatch("dms_portal/createSite", body).then((resp) => {
            this.$swal("Saved", "Saved data success", "success").then(() => {
              this.bodyAdd = {
                site_name: "",
                selectDepartment: [],
                site_link: ""
              };
              this.getSite();
              this.getDepartment();
              this.isLoading = false;
              this.$bvModal.hide("modal-1");
            });
          });
        } catch (error) {
          this.isLoading = false;
          this.$swal("Error", "Error while add data", "error");
        }
      });
    },

    editVariables(props) {
      console.log("props", props);
      this.$bvModal.show("modal-2");
      this.bodyUpdate.id = props.id;
      this.bodyUpdate.selectDepartment = props.department;
      this.bodyUpdate.site_name = props.site_name;
      this.bodyUpdate.site_link = props.site_link;
    },
    saveUpdate() {
      let body = {
        id: this.bodyUpdate.id,
        site_name: this.bodyUpdate.site_name,
        site_link: this.bodyUpdate.site_link,
        department: this.bodyUpdate.selectDepartment
      };
      this.$store
        .dispatch("dms_portal/updateSite", body)
        .then((resp) => {
          this.$swal("Saved", "Your input has been saved", "success").then(
            (resp) => {
              this.getSite();
              this.$bvModal.hide("modal-2");
            }
          );
        })
        .catch((resp) => {
          this.$swal("Error", "Error while edit data", "error");
        });
    },

    deleteVariables(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Yes, delete it!"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("dms_portal/delSite", id)
            .then((resp) => {
              this.getSite();
              this.$swal("Deleted!", "Your data has been deleted.", "success");
            })
            .catch((resp) => {
              this.$swal("Error", "Error while delete data", "error");
            });
        }
      });
    }
  }
};
</script>
